import { render, staticRenderFns } from "./basicTable.vue?vue&type=template&id=85cd6aec&scoped=true"
import script from "./basicTable.vue?vue&type=script&lang=js"
export * from "./basicTable.vue?vue&type=script&lang=js"
import style0 from "./basicTable.vue?vue&type=style&index=0&id=85cd6aec&scoped=true&lang=css"
import style1 from "./basicTable.vue?vue&type=style&index=1&id=85cd6aec&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85cd6aec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85cd6aec')) {
      api.createRecord('85cd6aec', component.options)
    } else {
      api.reload('85cd6aec', component.options)
    }
    module.hot.accept("./basicTable.vue?vue&type=template&id=85cd6aec&scoped=true", function () {
      api.rerender('85cd6aec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/compensationManagement/compensationList/components/basicTable.vue"
export default component.exports